import React from 'react';
import clsx from 'clsx';

import { CustomerAuthLevel } from 'models/Customer';
import { Shipment } from 'models/shipments';
import { selectAuthLevel } from 'store/customer';
import { selectShipments } from 'store/shipment/shipment.selectors';
import { useAppDispatch, useAppSelector } from 'store/store';

import { myPostTrackDetails } from '../../../config/track-config';
import { clearNotification } from '../../../store/notification';
import { selectShipment } from '../../../store/selectRemove';
import OnboardingBanner from '../OnboardingBanner/OnboardingBanner';
import ShipmentList from './ShipmentList/ShipmentList';
import { ShipmentProp } from './ShipmentList/ShipmentListItem/ShipmentListItem';

import styles from './ListSection.module.scss';

const ListSection: React.FC<{ className?: string }> = ({ className, ...props }) => {
  const dispatch = useAppDispatch();
  const isAnon = useAppSelector(selectAuthLevel) === CustomerAuthLevel.ANONYMOUS;
  const shipments = useAppSelector(selectShipments);
  const selectedShipments = useAppSelector((state) => state.selectRemove.selectedShipments);
  const editMode = useAppSelector((state) => state.selectRemove.editMode);

  const handleItemSelectChange = (event: React.ChangeEvent<HTMLInputElement>, shipment: Shipment | ShipmentProp) => {
    const articleId = shipment?.articles?.length && shipment.articles[0].articleId;
    if (articleId) dispatch(selectShipment(articleId));
  };

  return (
    <div className={clsx(styles.listSectionWrapper, className)} {...props}>
      <ShipmentList
        shipments={shipments}
        editMode={editMode}
        onItemClick={() => {
          dispatch(clearNotification());
        }}
        selectedShipments={selectedShipments}
        onItemSelectChange={(event, shipment) => handleItemSelectChange(event, shipment)}
        config={{
          routerLink: true,
          trackDetailPath: myPostTrackDetails,
        }}
      />
      {isAnon && <OnboardingBanner />}
    </div>
  );
};

export default ListSection;
